<template>
  <div class="bank-wire-order">
    <h1 class="document-title">Zlecenie Przelewu Bankowego</h1>
    <div class="document-details">
      <div class="document-info">
        <p><strong>Numer dokumentu:</strong> {{ bankWireOrderDocument.documentNumber || '---' }}</p>
        <p><strong>Typ dokumentu:</strong> {{ bankWireOrderDocument.documentType || '---' }}</p>
        <p><strong>Data wystawienia:</strong> {{ formatDate(bankWireOrderDocument.documentIssueDateTime) || '---' }}</p>

      </div>

      <div class="party-info">
        <h2>Dane płatnika</h2>
        <p><strong>Nazwa:</strong> {{ bankWireOrderDocument.payerName || '---' }}</p>
        <p><strong>Numer konta:</strong> {{ bankWireOrderDocument.payerAccountNumber || '---' }}</p>
        <p><strong>Nazwa banku:</strong> {{ bankWireOrderDocument.payerBankName || '---' }}</p>
        <p><strong>Adres:</strong> {{ bankWireOrderDocument.payerAddress || '---' }}</p>
        <p><strong>NIP:</strong> {{ bankWireOrderDocument.payerNip || '---' }}</p>
      </div>

      <div class="party-info">
        <h2>Dane odbiorcy</h2>
        <p><strong>Nazwa:</strong> {{ bankWireOrderDocument.receiverName || '---' }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.receiverName || '---')"/></p>
        <p><strong>Numer konta:</strong> {{ bankWireOrderDocument.receiverAccountNumber || '---' }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.receiverAccountNumber || '---')"/></p>
        <p><strong>Nazwa banku:</strong> {{ bankWireOrderDocument.receiverBankName || '---' }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.receiverBankName || '---')"/></p>
        <p><strong>Adres:</strong> {{ bankWireOrderDocument.receiverAddress || '---' }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.receiverAddress || '---')"/></p>
        <p><strong>NIP:</strong> {{ bankWireOrderDocument.receiverNip || '---' }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.receiverNip || '---')"/></p>
      </div>



      <div class="payment-info">
        <p><strong>Kwota:</strong> {{ formatCurrency(bankWireOrderDocument.documentValue) || '---' }} {{ bankWireOrderDocument.documentCurrency }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.documentValue || '---')"/></p>
        <p><strong>Słownie:</strong> {{ paymentsHelperMethods.numberToTextPLN(bankWireOrderDocument.documentValue) || '---' }}</p>
        <p><strong>Tytuł płatności:</strong> {{ bankWireOrderDocument.paymentTitle || '---' }}         <i class="fas fa-copy copy-icon-container" @click="copyValueToClipboard(bankWireOrderDocument.paymentTitle || '---')"/></p>

      </div>
    </div>

    <div v-if="showCopyTooltipAlert" class="copy-tooltip" :key="copyTooltipContent">
      <b-alert show dismissible variant="success">

        <i class="fas fa-check-circle"></i> Skopiowano <br> {{ copyTooltipContent }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import {paymentsHelperMethods} from "./helper/paymentsHelperMethods";

export default {
  name: "BankWireOrderDocument",
  computed: {
    paymentsHelperMethods() {
      return paymentsHelperMethods
    }
  },
  props: {
    bankWireOrderDocument: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showCopyTooltipAlert: false,
      copyTooltipContent: '',
      copyStatusTimeout: null,
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return new Date(date).toLocaleDateString();
    },
    formatCurrency(value) {
      if (value === null) return null;
      return Number(value).toFixed(2);
    },
    async copyValueToClipboard(value) {
      this.showCopyTooltip(value);

      try {
        await this.copyToClipboard(value);
      } catch (error) {
        this.copyTooltipContent = 'Kopiowanie nie powiodło się!';
      }

      if (this.copyStatusTimeout) clearTimeout(this.copyStatusTimeout);
      this.copyStatusTimeout = setTimeout(() => {
        this.copyTooltipContent = '';
        this.showCopyTooltipAlert = false;
      }, 5000);
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        console.error('Clipboard write failed:', err);
        throw err;
      }
    },
    showCopyTooltip(value) {
      this.copyTooltipContent = value;

      if (this.copyTooltipContent.length > 0) {

        this.showCopyTooltipAlert = true;
      }

      // Add global click listener
      if (!this.clickListener) {
        this.clickListener = (e) => {
          if (!e.target.closest('.copy-tooltip')) {
            // ide tooltip when clicked somewhere else
            if (this.copyTooltipContent.length > 0) {

              this.showCopyTooltipAlert = true;
            }
            this.copyStatusText = '';
          }
        };

      }
    },

  }
};
</script>

<style scoped>
.bank-wire-order {
  font-family: Arial, sans-serif;
  width: 748px;
  border: 1px solid #ccc;
  padding: 20px;
  margin: 20px auto;
  background-color: #f9f9f9;
}

.document-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.document-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.document-info, .party-info, .payment-info {
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

p {
  margin: 5px 0;
  font-size: 14px;
}

strong {
  font-weight: bold;
}

.copy-icon-container {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #007bff;
  font-size: 16px;
}

.copy-icon-container:hover {
  color: #0056b3;
}

/* Tooltip styles */
.copy-tooltip {
  position: fixed;
  z-index: 100100;
  transition: opacity 0.2s;
  max-width: 400px;
  animation: tooltipFadeIn 0.15s ease-out;
  right:0px;
  bottom:0px;
  margin-bottom:16px;
  margin-right: 8px;
}
</style>
